import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M3.958 4.792c0-.46.373-.834.834-.834h2.916c.46 0 .834.373.834.834v2.916c0 .46-.373.834-.834.834H4.792a.833.833 0 0 1-.834-.834V4.792Zm0 7.5c0-.46.373-.834.834-.834h2.916c.46 0 .834.373.834.834v2.916c0 .46-.373.834-.834.834H4.792a.833.833 0 0 1-.834-.834v-2.916Zm7.5-7.5c0-.46.373-.834.834-.834h2.916c.46 0 .834.373.834.834v2.916c0 .46-.374.834-.834.834h-2.916a.833.833 0 0 1-.834-.834V4.792Zm0 7.5c0-.46.373-.834.834-.834h2.916c.46 0 .834.373.834.834v2.916c0 .46-.374.834-.834.834h-2.916a.833.833 0 0 1-.834-.834v-2.916Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);